/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import { usePaymentStore } from '@/lib/store/paymentStore';
import { getDeviceId } from '@/lib/device';
import type { ApiRequestOptions } from './ApiRequestOptions';

type Resolver<T> = (options: ApiRequestOptions) => Promise<T>;
type Headers = Record<string, string>;

export type OpenAPIConfig = {
    BASE: string;
    VERSION: string;
    WITH_CREDENTIALS: boolean;
    CREDENTIALS: 'include' | 'omit' | 'same-origin';
    TOKEN?: string | Resolver<string> | undefined;
    USERNAME?: string | Resolver<string> | undefined;
    PASSWORD?: string | Resolver<string> | undefined;
    HEADERS?: Headers | Resolver<Headers> | undefined;
    ENCODE_PATH?: ((path: string) => string) | undefined;
    TIMEOUT?: number | undefined;
};

export const OpenAPI: OpenAPIConfig = {
    BASE: import.meta.env.VITE_API_URL || '',
    VERSION: '1.0',
    WITH_CREDENTIALS: false,
    CREDENTIALS: 'include',
    TOKEN: () => Promise.resolve(usePaymentStore.getState().paymentPayload?.token || ""),
    USERNAME: undefined,
    PASSWORD: undefined,
    HEADERS: async () => ({ 'X-Device-Id': await getDeviceId() }),
    ENCODE_PATH: undefined,
    // A request that never settles leaves the capture flow permanently disabled.
    TIMEOUT: 60_000,
};
